<div
  [tooltip]="ui().label"
  [isDisabled]="!showTooltip()"
  class="d-flex align-items-center {{ status() === CardStatus.Removed ? 'opacity-50' : ui().color }}">
  <i
    class="pays-svg-icon ic-card-2 me-2"
    [ngClass]="ui().color"></i>
  <span class="text-body">{{ value() | slice: 8 : 16 | emptyIndicator }}</span>
  @if (ui().label) {
    <span
      class="badge icon-badge ms-2"
      [ngClass]="[ui().badge, ui().color]">
      @switch (status()) {
        @case (CardStatus.Blocked) {
          <span class="icon-stack">
            <i class="iconoir-slash"></i>
            <i class="iconoir-circle"></i>
          </span>
        }
        @case (CardStatus.New) {
          <i class="iconoir-clock"></i>
        }
        @case (CardStatus.Removed) {
          <i class="iconoir-xmark-circle"></i>
        }
      }
    </span>
  }
</div>
